module.exports = "<ul class=\"form-control-feedback\" *ngIf=\"errors && errors.length\">\n  <li>\n    {{ errors[0] }}\n  </li>\n</ul>\n"